<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("users") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'user.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="users"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></v-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { fetchUsers, deleteUser } from "../shared/services";
import { persistentTableOptions } from "../../../plugins/mixins";
import _ from "lodash";

export default {
  name: "app-user-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false },
      ],
      loading: true,
      options: {
        itemsPerPage: 50,
      },
      total: 0,
      search: "",
      users: [],
      cancelTokenSource: null, // To store the cancel token source
      currentRequestId: 0,
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {

      this.currentRequestId++;
      const requestId = this.currentRequestId;

      // Cancel previous request if it exists
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("Operation canceled due to new request.");
      }

      // Create a new cancel token source
      this.cancelTokenSource = axios.CancelToken.source();

      this.loading = true;

      try {
        let response = await fetchUsers({
          ...this.options,
          search: this.search,
          cancelToken: this.cancelTokenSource.token, // Attach cancel token
        });
        if (requestId === this.currentRequestId) { 
            this.users = response.data;
            this.total = response.meta.total;
        }

      } catch (error) {
        if (axios.isCancel(error)) {
          /* eslint-disable no-console */
          console.log("Request canceled:", error.message);
        } else {
          /* eslint-disable no-console */
          console.error("Request failed:", error);
        }
      } finally {
        if (requestId === this.currentRequestId) {
          this.loading = false;
        }
      }
    },

    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this User?")
        )
      ) {
        let resp = await deleteUser(item.id);
        if (resp.data.success) {
          this.$notification(resp.data.message, { type: "success" });
        } else {
          this.$notification(resp.data.message, { type: "error" });
        }
        this.getData();
      }
    },

    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "user.edit", params: { id: url } });
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    search: {
      handler: _.debounce(function () {
        this.getData();
      }, 300), // 300ms debounce delay
      immediate: false,
    },
  },

  // eslint-disable-next-line no-unused-vars
  errorCaptured(err, vm, info) {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    // TODO: Perform any custom logic or log to server
    // return false to stop the propagation of errors further to parent or global error handler
  },
};
</script>